var DEFAULT_DURATION_MINUTES = 60;
function formatGoogleCalendarDate(date) {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}
export function buildGoogleCalendarUrl(event) {
    var _a, _b;
    var start = new Date(event.date);
    var end = new Date(start.getTime() + DEFAULT_DURATION_MINUTES * 60000);
    var params = new URLSearchParams({
        action: 'TEMPLATE',
        text: event.name,
        dates: formatGoogleCalendarDate(start) + "/" + formatGoogleCalendarDate(end),
        location: (_b = (_a = event.city) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
    });
    return "https://calendar.google.com/calendar/render?" + params.toString();
}
